module.exports = __webpack_public_path__ + "static/media/WheatStage113.09019d43.PNG";